import Text from 'components/elements/texts/Text'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'
import styled from 'styled-components'

const footerText = CLIENT_SETTINGS.messages.footer

/**
 * フッター表示エリア
 */
const FooterArea: React.FC = () => {
  return (
    <React.Fragment>
      {footerText && (
        <StyledFooterArea>
          <Text>{footerText}</Text>
        </StyledFooterArea>
      )}
    </React.Fragment>
  )
}

export const StyledFooterArea = styled.div`
  padding: 16px;
  text-align: center;
  background: var(--color-footer);
`
export default FooterArea
